import { MDSHorizontalDivider, MDSTextField } from "@/mds/components";
import styled from "@emotion/styled";

// Styled components
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]};
  position: relative;
  overflow: visible;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const OptionLabel = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[1]};
`;

export const ExtraContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
  position: relative;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
`;

export const ExtraContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[3]};
  position: relative;
  transform-origin: top;
  transition: transform 0.2s ease-in-out;
`;

export const ExtraContentInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const StyledTextField = styled(MDSTextField)``;

export const LeftStyles = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const StyledHorizontalDivider = styled(MDSHorizontalDivider)`
  margin-top: ${({ theme }) => theme.spacing[3]};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
  background-color: ${({ theme }) => theme.colors.border.default};
`;
